// router.ts
import { loadComponentScript } from "./loadComponents";
import { MenuItem, menuNavigation } from "@models/menuNavigation";

const rootElement = document.getElementById("content");

/**
 * Função que procura um componente com base na rota fornecida,
 * incluindo subitens aninhados.
 */
function findComponentByPath(items: MenuItem[], route: string): (() => Promise<() => HTMLElement[]>) | undefined {
    for (const item of items) {
        if (item.path === route) {
            return item.component;
        }else if (item.subitems) {
            const subitemComponent = findComponentByPath(item.subitems, route);
            if (subitemComponent) {
                return subitemComponent;
            }
        }
    }
    // return () => import("@ui/pages/erro").then((module) => module.Erro);
}

/**
 * Função que navega para a rota especificada, carregando e renderizando o componente
 * correspondente no elemento HTML com a ID "content".
 */
export function navigateTo(route: string) {
    var component = findComponentByPath(menuNavigation.items, route);

    console.log(component)
    if(!component){
        component =  () => import("@ui/pages/erro").then((module) => module.Erro);
    }
    rootElement!.innerHTML = "";
    if (component) {
        component()
            .then((templates) => {
                const htmlTemplates = templates();
                htmlTemplates.map((element) => rootElement?.appendChild(element));
            })
            .catch((error) => {
                console.warn("⚠️ WARN: ", error.message);
                rootElement!.innerHTML = error.message;
            });
    }

    loadComponentScript();
}

/**
 * Inicializa o roteador e manipula eventos de popstate para atualizar
 * a rota com base na URL atual do navegador.
 */
export function initRouter() {
    function handlePopstate(event: PopStateEvent) {
        console.log("📢[index.ts:58]: event: ", event);
        navigateTo(window.location.pathname);
    }
    window.addEventListener("popstate", handlePopstate);
    navigateTo(window.location.pathname);
}

/**
 * Função que navega para a rota especificada e atualiza o histórico do navegador
 * usando pushState.
 */
export function navigate(route: string) {
    window.history.pushState(null, "", route);
    navigateTo(route);
}
